import { AppNavbar } from "../../components";
import { RecipeScreen1, RecipeScreen1alt, StoryScreen2 } from "../../containers";
import "./Recipe.css";


const Recipe = () => {

    return (
        <div className="recipe">
            <AppNavbar/>
            <RecipeScreen1alt/>
        </div>
    )
};

export default Recipe;